export const requiresSupplyAddressForType = (type) => ['supplies', 'change_ownership'].includes(type);

export const validateSupplyAddress = (type, data) => {
  const required = requiresSupplyAddressForType(type);
  const address = String(data.supply_address ?? '').trim();
  const postalCode = String(data.postal_code ?? '').trim();
  const municipality = String(data.municipality ?? '').trim();

  return {
    supply: required && !address,
    postal: postalCode ? !/^[0-9]{5}$/.test(postalCode) : required,
    municipality: required && !municipality,
  };
};
